import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingPageModule),
  },
  {
    path: 'created/:coupleId',
    loadChildren: () => import('./pages/created/created.module').then(m => m.CreatedPageModule),
  },
  {
    path: 'quiz/:coupleId',
    loadChildren: () => import('./pages/quiz/quiz.module').then(m => m.QuizPageModule),
  },
  {
    path: 'waiting/:coupleId',
    loadChildren: () => import('./pages/waiting/waiting.module').then(m => m.WaitingPageModule),
  },
  {
    path: 'results/:coupleId',
    loadChildren: () => import('./pages/results/results.module').then(m => m.ResultsPageModule),
  },
  {
    path: 'lobby/:pairId',
    loadChildren: () => import('./pages/lobby/lobby.module').then(m => m.LobbyPageModule),
  },
  {
    path: 'q/:coupleId',
    loadChildren: () => import('./pages/quiz-join/quiz-join.module').then(m => m.QuizJoinPageModule),
  },
  {
    path: 'group/new',
    loadChildren: () => import('./pages/group-new/group-new.module').then(m => m.GroupNewPageModule),
  },
  {
    path: 'group/:groupId/created',
    loadChildren: () => import('./pages/group-created/group-created.module').then(m => m.GroupCreatedPageModule),
  },
  {
    path: 'group/:groupId/join',
    loadChildren: () => import('./pages/group-join/group-join.module').then(m => m.GroupJoinPageModule),
  },
  {
    path: 'group/:groupId/waiting',
    loadChildren: () => import('./pages/group-waiting/group-waiting.module').then(m => m.GroupWaitingPageModule),
  },
  {
    path: 'group/:groupId/results',
    loadChildren: () => import('./pages/group-results/group-results.module').then(m => m.GroupResultsPageModule),
  },
  {
    path: 'my-quizzes',
    loadChildren: () => import('./pages/my-quizzes/my-quizzes.module').then(m => m.MyQuizzesPageModule),
  },
  {
    path: '__admin-question-lab-7f3c9d',
    loadChildren: () => import('./pages/question-lab/question-lab.module').then(m => m.QuestionLabPageModule),
  },
  {
    path: '__admin-quiz-builder-9a2e4f',
    loadChildren: () => import('./pages/quiz-builder/quiz-builder.module').then(m => m.QuizBuilderPageModule),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
